import React, { useRef, useState } from 'react';
import api from '../services/api';

/**
 * Botón de subida de documento al expediente del paciente.
 * @param {string} pacienteId
 * @param {(expediente) => void} onUploadSuccess
 * @param {string} [categoria]  'GENERAL' | 'DNI' | 'CONSENTIMIENTO' | 'INFORME' | 'PRUEBA'
 * @param {string} [label]      Texto del botón
 * @param {string} [accept]     Tipos de archivo aceptados
 * @param {'primary'|'slate'}  [tono]
 */
const BotonSubirDocumento = ({
    pacienteId,
    onUploadSuccess,
    categoria = 'GENERAL',
    label = 'Añadir archivo clínico',
    accept = '.pdf,.jpg,.jpeg,.png,.doc,.docx',
    tono = 'primary'
}) => {
    const [subiendo, setSubiendo] = useState(false);
    const fileInputRef = useRef(null);

    const handleFileChange = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        if (file.size > 10 * 1024 * 1024) {
            alert('El archivo supera el límite de 10MB permitido por seguridad.');
            event.target.value = null;
            return;
        }

        const formData = new FormData();
        formData.append('archivo', file);
        formData.append('categoria', categoria);

        try {
            setSubiendo(true);
            const response = await api.post(`/pacientes/${pacienteId}/upload`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            const nuevoExpediente = response.data || response.expediente || response;
            if (onUploadSuccess) onUploadSuccess(nuevoExpediente);
        } catch (error) {
            console.error('Error de red al subir el archivo:', error);
            alert(error.response?.data?.message || error.message || 'Error al guardar el archivo en el servidor.');
        } finally {
            setSubiendo(false);
            if (fileInputRef.current) fileInputRef.current.value = null;
        }
    };

    const clases = tono === 'slate'
        ? 'bg-slate-100 text-slate-700 border border-slate-200 hover:bg-slate-200'
        : 'bg-clinica-primary text-white hover:bg-blue-700 shadow-md shadow-blue-500/20';

    return (
        <>
            <input type="file" ref={fileInputRef} className="hidden" accept={accept} onChange={handleFileChange} />
            <button
                type="button"
                onClick={() => fileInputRef.current && fileInputRef.current.click()}
                disabled={subiendo}
                className={`inline-flex items-center gap-2 px-5 py-2.5 rounded-xl text-sm font-bold transition-all disabled:opacity-60 ${clases}`}
            >
                {subiendo ? (
                    <span className="w-4 h-4 border-2 border-current border-t-transparent rounded-full animate-spin"></span>
                ) : (
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"></path></svg>
                )}
                {subiendo ? 'Guardando…' : label}
            </button>
        </>
    );
};

export default BotonSubirDocumento;
